import backdropMain from '@/assets/backdrop-main.png';
import { Box } from '@mui/material';
import React, { type PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import { BodyContainer } from './BodyContainer.tsx';
import { UnifiedHeader } from './UnifiedHeader.tsx';

type LayoutProps = object;

export const Layout: React.FC<PropsWithChildren<LayoutProps>> = () => {
  // leave spacing for side menu bar if app isn't being used as the mobile version
  return (
    <React.Fragment key={'layout'}>
      {/* Fixed background image */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${backdropMain})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          zIndex: -1,
        }}
      />
      <Box
        sx={{
          display: 'grid',
          gridTemplateRows: 'auto 1fr',
          height: '100vh',
          overflow: 'hidden',
        }}
      >
        <UnifiedHeader />
        <BodyContainer>
          <Outlet />
        </BodyContainer>
      </Box>
    </React.Fragment>
  );
};
